import localStorageService from '../services/localStorageService';

const axios = require('axios');

axios.defaults.headers.common['Authorization'] = localStorageService.getAuth();

export default axios;
